<template>
    <div class="timeStampConverter">
      <div class='container'>
        <div class='row text-center'>
          <div class='col-md-12'>
            <textarea class="form-control" rows="10" placeholder="请输入13位时间戳,多个时间戳用逗号分隔" v-model="timestampStr"></textarea>
            <br>
            <div class="btn btn-primary" @click="convertTime" style="margin-bottom:40px">转换时间</div>
            <br>
          </div>
          <div class='col-md-12'>
            <p v-html="resultMsg"></p>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'TimeStampConverter',
    data() {
      return {
        timestampStr: "",
        resultMsg: "",
      }
    },
    methods: {
      convertTime() {
        this.resultMsg = "";
        var timestampArr = this.timestampStr.split(',');
        for(var i = 0; i < timestampArr.length; i++) {
          var timestamp = timestampArr[i].trim();
          if(this.isValidTimestamp(timestamp)) {
            var date = new Date(parseInt(timestamp));
            var formattedDate = this.formatDate(date);
            this.resultMsg += `<span style='color:green'>${timestamp}: ${formattedDate}</span><br>`;
          } else {
            this.resultMsg += `<span style='color:red'>${timestamp}: 无效的时间戳</span><br>`;
          }
        }
      },
      isValidTimestamp(timestamp) {
        return /^\d{13}$/.test(timestamp);
      },
      formatDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      }
    }
  }
  </script>
  
  <style scoped>
  .timeStampConverter {
    padding: 20px;
  }
  </style> 